import type { ReactNode } from "react";
import { getThemeColors } from "../lib/theme";

interface EmptyStateProps {
  icon: ReactNode;
  message: string;
  isDark: boolean;
  className?: string;
}

export function EmptyState({
  icon,
  message,
  isDark,
  className = "",
}: EmptyStateProps) {
  const theme = getThemeColors(isDark);

  return (
    <div className={`text-center py-16 ${theme.textMuted} ${className}`}>
      <div className="w-16 h-16 mx-auto mb-4 -rotate-3 rounded-2xl border-[3px] border-ink bg-gold shadow-board flex items-center justify-center">
        <div className="w-8 h-8 text-ink">
          {icon}
        </div>
      </div>
      <p className={`font-display text-base ${theme.text}`}>{message}</p>
    </div>
  );
}
